function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { nanoid } from "nanoid";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { pushDialog, removeDialog } from "../modules";
import { Emitter } from "../services";
import { DIALOG_TYPES } from "../types";
var useAppDispatch = function() {
    return useDispatch();
};
export var useDialogs = function() {
    var dispatch = useAppDispatch();
    var openDialog = useCallback(function(id, props) {
        dispatch(pushDialog(_object_spread({
            id: id
        }, props)));
        return new Promise(function(resolve) {
            return Emitter.on(id, resolve);
        });
    }, [
        dispatch
    ]);
    var createDialogHandlers = useCallback(function(id, key, closeEventId) {
        var onCloseHandler = null;
        var onSubmitHandler = null;
        var cleanup = function() {
            if (onCloseHandler) {
                Emitter.off(closeEventId, onCloseHandler);
            }
            if (onSubmitHandler) {
                Emitter.off(id, onSubmitHandler);
            }
        };
        var onClose = function(closeHandler) {
            closeHandler === null || closeHandler === void 0 ? void 0 : closeHandler();
            cleanup();
        };
        var onSubmit = function(handler, data) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            Emitter.emit(key, true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                handler(data)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            queueMicrotask(function() {
                                return Emitter.emit(key, false);
                            });
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var registerHandlers = function(handler, closeHandler) {
            onCloseHandler = function() {
                return onClose(closeHandler);
            };
            onSubmitHandler = function(data) {
                return onSubmit(handler, data);
            };
            Emitter.on(closeEventId, onCloseHandler);
            Emitter.on(id, onSubmitHandler);
        };
        return {
            registerHandlers: registerHandlers
        };
    }, []);
    var openListenerDialog = useCallback(function(id, props, parent) {
        var key = "promise-".concat(id);
        var closeEventId = "close-".concat(id);
        dispatch(pushDialog(_object_spread({
            id: id,
            parent: parent
        }, props)));
        return {
            on: function(handler, closeHandler) {
                var handlers = createDialogHandlers(id, key, closeEventId);
                handlers.registerHandlers(handler, closeHandler);
            }
        };
    }, [
        dispatch,
        createDialogHandlers
    ]);
    var openConfirmDialog = useCallback(function(props) {
        return openDialog(nanoid(), {
            props: props,
            type: DIALOG_TYPES.confirm
        });
    }, [
        openDialog
    ]);
    var openFormDialog = useCallback(function(id, props, parentId) {
        return openListenerDialog(id, {
            props: props,
            type: DIALOG_TYPES.form
        }, parentId);
    }, [
        openListenerDialog
    ]);
    var closeDialog = useCallback(function(id) {
        Emitter.emit("close-".concat(id), true);
        dispatch(removeDialog(id));
        Emitter.off("promise-".concat(id));
        Emitter.off("close-".concat(id));
        Emitter.off(id);
    }, [
        dispatch
    ]);
    return {
        closeDialog: closeDialog,
        openConfirmDialog: openConfirmDialog,
        openFormDialog: openFormDialog
    };
};

//# sourceMappingURL=useDialogs.js.map